import React from 'react';
import { useTranslation } from 'react-i18next';
import { Landmark, Smartphone, Link2, Banknote } from 'lucide-react';
import { StepHeader, WizInput, WizSwitch } from '../wizardUi';

function PaymentMethod({ icon, title, enabled, onToggle, label, value, onChange, placeholder }) {
  return (
    <div
      className={`overflow-hidden rounded-[22px] border bg-white/[0.04] transition-colors ${
        enabled ? 'border-primary/40' : 'border-white/[0.08]'
      }`}
    >
      <div className="flex items-center justify-between gap-3 px-5 py-4">
        <span className="flex items-center gap-3 text-[14.5px] font-medium">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/[0.06] text-white/70">{icon}</span>
          {title}
        </span>
        <WizSwitch checked={enabled} onCheckedChange={onToggle} label={title} />
      </div>
      <div
        className="overflow-hidden transition-[max-height] duration-300 ease-out"
        style={{ maxHeight: enabled ? 120 : 0 }}
      >
        <div className="flex flex-col gap-2 px-5 pb-5">
          <label className="text-[13px] font-medium text-white/60">{label}</label>
          <WizInput value={value} onChange={onChange} placeholder={placeholder} tabIndex={enabled ? 0 : -1} />
        </div>
      </div>
    </div>
  );
}

export default function Step3Payments({ wizard }) {
  const { t } = useTranslation();
  const { payments, setPaymentEnabled, setPaymentField } = wizard;

  return (
    <div className="flex flex-col gap-5 lg:gap-6">
      <StepHeader eyebrow={t('wizardIg.eyebrow', { n: 3 })} title={t('wizardIg.title2')} sub={t('wizardIg.sub2')} />

      <div className="flex flex-col gap-4 lg:grid lg:grid-cols-2 lg:items-start">
        <PaymentMethod
          icon={<Landmark size={17} />}
          title={t('wizardIg.payBankTitle')}
          enabled={payments.bank.enabled}
          onToggle={(v) => setPaymentEnabled('bank', v)}
          label={t('wizardIg.payBankLabel')}
          value={payments.bank.account}
          onChange={(e) => setPaymentField('bank', 'account', e.target.value)}
          placeholder="CR00 0000 0000 0000 0000 00"
        />

        <PaymentMethod
          icon={<Smartphone size={17} />}
          title={t('wizardIg.paySinpeTitle')}
          enabled={payments.sinpe.enabled}
          onToggle={(v) => setPaymentEnabled('sinpe', v)}
          label={t('wizardIg.paySinpeLabel')}
          value={payments.sinpe.number}
          onChange={(e) => setPaymentField('sinpe', 'number', e.target.value)}
          placeholder="+506 8888 0000"
        />

        <PaymentMethod
          icon={<Link2 size={17} />}
          title={t('wizardIg.payLinkTitle')}
          enabled={payments.link.enabled}
          onToggle={(v) => setPaymentEnabled('link', v)}
          label={t('wizardIg.payLinkLabel')}
          value={payments.link.url}
          onChange={(e) => setPaymentField('link', 'url', e.target.value)}
          placeholder="https://pay.me/your-business"
        />

        <div
          className={`flex items-center justify-between gap-3 rounded-[22px] border bg-white/[0.04] px-5 py-4 transition-colors ${
            payments.cash.enabled ? 'border-primary/40' : 'border-white/[0.08]'
          }`}
        >
          <span className="flex items-center gap-3 text-[14.5px] font-medium">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/[0.06] text-white/70">
              <Banknote size={17} />
            </span>
            {t('wizardIg.payCashTitle')}
          </span>
          <WizSwitch
            checked={payments.cash.enabled}
            onCheckedChange={(v) => setPaymentEnabled('cash', v)}
            label={t('wizardIg.payCashTitle')}
          />
        </div>
      </div>
    </div>
  );
}
